module.exports = __webpack_public_path__ + "img/ic_language.9d6f5548.svg";